module.exports = __webpack_public_path__ + "static/dm-section-c4da04237cc656c03a6850a41d15bd55.svg";